import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    closeEditPopup,
    entityAddSuccess,
    entityEditSuccess
} from '../../actions/grid-screen';
import {
    EditEntityControl,
    EditEntityControlProps
} from '../../components/EditEntityControl/EditEntityControl';
import { selectEditedEntity } from '../../selectors/grid/grid';
import { SaveSuccessData } from '../../typings/common';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export type StateProps = TStateProps<EditEntityControlProps>;

export type DispatchProps = TDispatchProps<EditEntityControlProps>;

const mapStateToProps = (state: State): StateProps => {
    const editedEntity = selectEditedEntity(state);

    return {
        editedEntity
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onEditPopupClose: () => {
            dispatch(closeEditPopup());
        },
        onEditSuccess: () => {
            dispatch(entityEditSuccess());
        },
        onAddSuccess: (data: SaveSuccessData) => {
            dispatch(entityAddSuccess(data));
        }
    };
};

export const EditEntityContainer = connect<StateProps, DispatchProps, {}>(
    mapStateToProps,
    mapDispatchToProps
)(EditEntityControl);
